export default __webpack_public_path__ + "static/media/add.8a917897.svg";